export const messagesEmail = {
    pt: {
        message:{
            authenticateDomain: "Autenticar seu domínio",
            basic: "Básicos",
            bodyIsFilledOut: "O corpo do seu e-mail está preenchido",
            bodyIsNotFilledOut: "O corpo do seu e-mail não está preenchido",
            bounces: "Bounces",
            clicks: "Cliques",
            createEmail: "Criar e-mail",
            customSegmentedList: "Lista segmentada customizada de cadastros",
            deleteDomain: "Deletar Domínio?",
            deleteDomainConfirmation: "Quer mesmo deletar este domínio? Esta ação é irreversível",
            domain: "Domínio",
            domainToUse: "Domínio que você quer usar",
            domainValidationHint: "A validação de domínio serve para que seus e-mails sejam mandados de um endereço que você possui",
            emailContent: "Conteúdo do e-mail",
            emailSettings: "Configurações de e-mail",
            emails: "E-mails",
            emailAutomationInfo: "Crie um e-mail que será utilizado nos seus fluxos de automação do WiFeed.",
            emailName: "Nome do e-mail",
            emailPurpose: "Finalidade do e-mail:",
            emailSingleSendInfo: "Envie seu e-mail uma única vez para sua base de clientes a partir de uma segmentação.",
            externalBase: "Base externa",
            finish: "Finalizar",
            hintSeveralEmails: "Utilize vírgulas para enviar vários e-mails.",
            host: "Host",
            newEmail: "Novo e-mail",
            opened: "Aberturas",
            pending: "Pendente",
            previous: "Voltar",
            readyTemplates: "Modelos prontos",
            sender: "Remetente",
            senderData: "Dados do remetente",
            senderEmail: "E-mail do remetente",
            senderName: "Nome do remetente",
            simpleSegmentedList: "Lista segmentada de cadastros",
            subdomain: "Subdomínio",
            subdomainHint: "O subdomínio é opcional. Ele representa algum endereço que faz parte do seu domínio. Então se, por exemplo, vocês quisesse mandar seu e-mail de marketing.wifeed.com.br, o subdomínio seria 'marketing'",
            subject: "Assunto",
            subjectLength1: "O assunto do seu e-mail tem ",
            subjectLength2: "caracteres, o limite máximo é 60.",
            textPreview: "Prévia do texto",
            tooltipEmailName: "Nome que será utilizado para identificar o e-mail dentro do WiFeed.",
            tooltipEmailSubject: "Texto que aparecerá como assunto do e-mail. Será visto na caixa de e-mails dos destinatários.",
            tooltipSenderEmail: "Este é o endereço de e-mail que aparecerá ao destinatário.",
            tooltipSenderName: "Nome de quem está enviando o e-mail. Aparecerá na caixa de e-mails dos destinatários.",
            tooltipTextPreview: "Esta é uma informação que aparecerá após o assunto, na caixa de e-mail dos destinatários. Ela pode ser usada para complementar o texto do assunto.",
            type: "Tipo",
            validate: "Validar",
            validateDomains: "Validar domínios",
            validateNewDomain: "Validar novo domínio",
            validated: "Validado",
            validatedDomains: "Domínios validados",
            validEmailWarning: "Utilize um e-mail existente para ter acesso às respostas que seus clientes enviarem.",
            value: "Valor",
            verify: "Verificar",
            viewDetails: "Ver detalhes",
            wholeDatabase: "Toda a base",
            systemCommunicationsEmailVariable: "Variáveis do e-mail",
            systemCommunicationsEmailModalConfirmation: "Para que os envios de e-mail de notificação ocorram corretamente, o sistema faz uso de identificadores especiais chamados de variáveis. Essas variáveis são palavras entre chaves presentes na mensagem que, no momento do envio do email, serão substituídas pela informação exata do destinatário.",
            systemCommunicationsEmailModalConfirmationHtml: `Exemplo: Na mensagem <code>Olá, {PRIMEIRO_NOME}!</code>, essa variável
                será substituída pelo nome do destinatário. <br />
                <br />
                É importante observar que existem variáveis opcionais e variáveis
                obrigatórias. Para entender melhor e ter acesso à essas variáveis,
                clique no botão <strong>Variáveis do e-mail</strong> localizado na
                parte superior direita do editor.`,
            systemCommunicationsEmailModalConfirmationButton: 'Ok, entendi.',
            systemCommunicationsEmailWelcomeTitle: 'E-mail de boas vindas',
            systemCommunicationsEmailRecoveryTitle: 'E-mail de recuperação de senha'
        }
    },
    es: {
        message:{
            authenticateDomain:"Autenticar tu dominio",
            basic:"Básico",
            bodyIsFilledOut:"El cuerpo de su correo electrónico está lleno",
            bodyIsNotFilledOut:"El cuerpo de tu correo electrónico no está lleno",
            bounces:"Rebotes",
            clicks:"Clics",
            createEmail:"Crear correo electrónico",
            customSegmentedList: "Lista segmentada personalizada de registros",
            deleteDomain:"¿Eliminar el dominio?",
            deleteDomainConfirmation:"¿Realmente quieres eliminar este dominio? Esta acción es irreversible",
            domain:"Dominio",
            domainToUse:"Dominio que quieres usar",
            domainValidationHint:"La validación de dominio es para que se envíen sus correos electrónicos desde una dirección que tiene",
            emailContent:"Contenido de correo electrónico",
            emailSettings:"Ajustes del correo electrónico",
            emails:"Correos electrónicos",
            emailAutomationInfo:"Cree un correo electrónico que se utilizará en sus flujos de automatización de WiFeed",
            emailName:"Nombre de correo electrónico",
            emailPurpose:"Propósito de correo electrónico:",
            emailSingleSendInfo:"Envíe su correo electrónico una vez a su base de clientes desde una segmentación",
            externalBase:"Base externa",
            finish:"Finalizar",
            hintSeveralEmails:"Use comas para enviar múltiples correos electrónicos",
            host:"Host",
            newEmail:"Nuevo Email",
            opened:"Abierto",
            pending:"Pendiente",
            previous:"Volver",
            readyTemplates:"Modelos listos",
            sender:"Remitente",
            senderData:"Datos del remitente",
            senderEmail:"Correo electrónico del remitente",
            senderName:"Nombre del remitente",
            simpleSegmentedList:"Lista segmentada de registros",
            subdomain:"Subdominio",
            subdomainHint:"El subdominio es opcional. Representa una dirección que es parte de su dominio. Entonces, si, por ejemplo, desea enviar su correo electrónico a marketing.wifeed.com.br, el subdominio sería 'marketing'",
            subject:"Asunto",
            subjectLength1:"El asunto de su correo electrónico tiene",
            subjectLength2:"caracteres, el límite máximo es 60.",
            textPreview:"Vista previa del texto",
            tooltipEmailName:"Nombre que se utilizará para identificar el correo electrónico dentro de WiFeed",
            tooltipEmailSubject:"Texto que aparecerá como asunto del correo electrónico. Se verá en el cuadro de correo electrónico del destinatario",
            tooltipSenderEmail:"Esta es la dirección de correo electrónico que aparecerá al destinatario",
            tooltipSenderName:"Nombre de quién está enviando el correo electrónico. Aparecerá en la casilla de correo electrónico de los destinatarios",
            tooltipTextPreview:"Esta es información que aparecerá después del sujeto, en el cuadro de correo electrónico del destinatario. Se puede utilizar para complementar el texto del sujeto",
            type:"Tipo",
            validate:"Validar",
            validateDomains:"Validar dominios",
            validateNewDomain:"Validar el nuevo dominio",
            validated:"Validado",
            validatedDomains:"Dominios validados",
            validEmailWarning:"Use un correo electrónico existente para acceder a las respuestas que envían sus clientes",
            value:"Valor",
            verify:"Verificar",
            viewDetails:"Ver detalles",
            wholeDatabase:"Toda la base",
            systemCommunicationsEmailVariable: "Variables de correo electrónico",
            systemCommunicationsEmailModalConfirmation: "Para que el envío del correo electrónico de notificación se realice correctamente, el sistema hace uso de identificadores especiales llamados variables. Estas variables son palabras encerradas entre llaves presentes en el mensaje que, cuando se envía el correo electrónico, serán reemplazadas por la información exacta del destinatario. ",
            systemCommunicationsEmailModalConfirmationHtml: `Ejemplo: En el mensaje <code>¡Hola, {FIRST_NAME}!</code>, esta variable
                será reemplazado con el nombre del destinatario. <br />
                <br />
                Es importante tener en cuenta que existen variables opcionales y variables opcionales.
                obligatorio. Para comprender mejor y tener acceso a estas variables,
                haga clic en el botón <strong>Variables de correo electrónico</strong> ubicado en la
                parte superior derecha del editor.`,
            systemCommunicationsEmailModalConfirmationButton: 'OK entendí.',
            systemCommunicationsEmailWelcomeTitle: 'Correo electrónico de bienvenida',
            systemCommunicationsEmailRecoveryTitle: 'Correo electrónico de recuperación de contraseña'
        }
    },
    en: {
        message:{
            authenticateDomain: "Authenticate your domain",
            basic: "Basic",
            bodyIsFilledOut: "The body of your email is filled out",
            bodyIsNotFilledOut: "The body of your email is not filled out",
            bounces: "Bounces",
            clicks: "Clicks",
            createEmail: "Create email",
            customSegmentedList: "Custom segmented list of registrations",
            deleteDomain: "Delete Domain?",
            deleteDomainConfirmation: "Do you really want to delete this domain? This action is irreversible",
            domain: "Domain",
            domainToUse: "Domain you want to use",
            domainValidationHint: "Domain validation is for your emails to be sent from an address you own",
            emailContent: "Email content",
            emailSettings: "Email settings",
            emails: "Emails",
            emailAutomationInfo: "Create an email that will be used in your WiFeed automation flows.",
            emailName: "Email name",
            emailPurpose: "Purpose of the email:",
            emailSingleSendInfo: "Send your email once to your customer base based on segmentation.",
            externalBase: "External customer base",
            finish: "Finish",
            hintSeveralEmails: "Use commas to send multiple emails.",
            host: "Host",
            newEmail: "New email",
            opened: "Opened",
            pending: "Pending",
            previous: "Previous",
            readyTemplates: "Ready templates",
            sender: "Sender",
            senderData: "Sender data",
            senderEmail: "Sender email",
            senderName: "Sender name",
            simpleSegmentedList: "Segmented list of registrations",
            subdomain: "Subdomain",
            subdomainHint: "The subdomain is optional. It represents some address that is part of your domain. So if, for example, you wanted to send your email from marketing.wifeed.com.br, the subdomain would be 'marketing'\n",
            subject: "Subject",
            subjectLength1: "The subject of your email has ",
            subjectLength2: "characters, the max limit is 60.",
            textPreview: "Text preview",
            tooltipEmailName: "Name that will be used to identify the email within WiFeed.",
            tooltipEmailSubject: "Text that will appear as the subject of the email. It will be seen in the recipients' email box.",
            tooltipSenderEmail: "This is the email address that will appear to the recipient.",
            tooltipSenderName: "Name of the person sending the email. It will appear in the recipients' email box.",
            tooltipTextPreview: "This information will appear after the subject in the recipients' email box. It can be used to supplement the subject text.",
            type: "Type",
            validate: "Validate",
            validateDomains: "Validate domains",
            validateNewDomain: "Validate new domain",
            validated: "Validated",
            validatedDomains: "Validated domains",
            validEmailWarning: "Use an existing email address to access responses your customers send.",
            value: "Value",
            verify: "Verify",
            viewDetails: "View details",
            wholeDatabase: "Whole Database",
            systemCommunicationsEmailVariable: "Email variables",
            systemCommunicationsEmailModalConfirmation: "For notification email sending to occur correctly, the system makes use of special identifiers called variables. These variables are words enclosed in curly braces present in the message which, when the email is sent, will be replaced by the recipient's exact information .",
            systemCommunicationsEmailModalConfirmationHtml: `Example: In the message <code>Hello, {FIRST_NAME}!</code>, this variable
                will be replaced with the recipient's name. <br />
                <br />
                It is important to note that there are optional variables and optional variables
                mandatory. To better understand and have access to these variables,
                click on the <strong>Email Variables</strong> button located in the
                top right part of the editor.`,
            systemCommunicationsEmailModalConfirmationButton: 'Ok, I got it.',
            systemCommunicationsEmailWelcomeTitle: 'Welcome email',
            systemCommunicationsEmailRecoveryTitle: 'Password recovery email'
        }
    }
}
